import { useQuery } from '@tanstack/react-query';

import { TokenContentApiReponse } from '@/lib/api/tokens/types';

import { fetcher } from '@/utils/fetcher';
import { routes } from '@/utils/routes';
import { objectToQueryString } from '@/utils/string';

export const NATIVE_USDC_HELP_TEXT =
  'Native USDC is issued by Circle and is redeemable 1:1 for US dollars.';

export const customContentQueryKey = (
  tokenAddress: string | undefined,
  chainId: number | undefined,
) => ['token-content', tokenAddress, chainId] as const;

export const customContentFetcher = async (tokenAddress?: string, chainId?: number) =>
  fetcher<TokenContentApiReponse>(
    `${routes.api.TOKENS_CONTENT}${objectToQueryString({ tokenAddress, chainId })}`,
  );

/**
 * Fetches Custom Content for USDC token pages and others.
 */
export const useCustomContent = (tokenAddress: string | undefined, chainId: number | undefined) => {
  return useQuery<TokenContentApiReponse, Error>({
    queryKey: customContentQueryKey(tokenAddress, chainId),
    queryFn: () => customContentFetcher(tokenAddress, chainId),
    enabled: tokenAddress != null && chainId != null,
    refetchOnReconnect: false,
    staleTime: 60_000,
  });
};
